// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'accessCodeForm.accessCodeInputLabel': 'Enter Access Code',
  'accessCodeForm.birthdayInputLabel': 'Enter your Birthday (mm/dd/yyyy)',
  'accessCodeForm.accessConversationButton': 'Go to conversation',
  'accessCodeForm.licenseAgreement': "By continuing you agree to TigerConnect's ",
  'accessCodeForm.loginErrorDetails': "Information didn't match. {number} {placeholder} left.",
  'accessCodeForm.openLicenseAgreement': 'End User License Agreement',
  'accessCodeForm.supportResendSubFooter': "Didn't receive an access code?",
  'accessCodeForm.resendButton': 'Tap here to resend',
  'accessCodeForm.callSupportSubFooter': "If you're having issues please call",
  'accessCodeForm.codeResendSuccessfully': 'Access code sent successfully',
  'accessCodeForm.codeResendError':
    'An error occurred when trying to resend the access code, please try again',
  'accessCodeForm.required': '(required)',
  'accessCodeForm.formLabel': 'Access Code Form',
  'accessCodeForm.footerLabel': 'Access Code Footer',
};
